import {IdCodeNameQuery} from "../../models/base.query";
import { ClassificatorValueQuery } from "./classificator-value.query";

export class ClassificatorQuery extends IdCodeNameQuery {
  ClassificatorValues: ClassificatorValueQuery[] = [];
  Comment: string;
  ParentId: string;
  TypeClv: string;

  static Columns() {
    return [...IdCodeNameQuery.Columns(), 'Values', 'Comment', 'ParentId', 'TypeClv'];
  }
}

